export default {
  'ui:order': [
    'firstName',
    'lastName',
    'address',
    'state',
    'zipCode',
    'emailAddress'
  ],
  'state': {
    'ui:widget': 'select'
  }
}



// WEBPACK FOOTER //
// ./src/components/container/signup/ui-schema.js